import { ReactElement, useMemo } from 'react';
import { MapInfoContainer } from '../../styles';
import {
  buildHealthyInfo, buildHealthInfoCardProps, buildThermalComfortInfoCardProps, buildThermalComfortInfo,
} from '~/pages/NewOverview/helpers/map';
import { InfoCard } from '../InfoCard';
import { HealthUnitsInfo } from 'pages/NewOverview/contexts/HealthDataContext';
import { StateHint } from '../StateHint';
import { UnitHint } from '../UnitHint';
import { ThermalComfortUnitsInfo } from 'pages/NewOverview/contexts/ThermalComfortDataContext';

type MapInfoProps =
  | {
      type: 'health';
      unitsMap: Map<string, HealthUnitsInfo>;
      scope: 'state' | 'unit';
      selected: boolean;
      onCloseInfoCard: () => void;
      name?: string;
      unitInfo?: { id: number; city: string };
      state?: string;
    }
  | {
      type: 'thermalComfort';
      unitsMap: Map<string, ThermalComfortUnitsInfo>;
      scope: 'state' | 'unit';
      selected: boolean;
      onCloseInfoCard: () => void;
      name?: string;
      unitInfo?: { id: number; city: string };
      state?: string;
    };

export function MapInfo({
  name,
  scope,
  unitsMap,
  unitInfo,
  selected,
  state,
  onCloseInfoCard,
  type,
}: Readonly<MapInfoProps>): ReactElement {
  const infoProps = useMemo(
    () => {
      if (type === 'health') {
        return buildHealthInfoCardProps(scope, buildHealthyInfo(scope, unitsMap, name, state, unitInfo?.id));
      }

      return buildThermalComfortInfoCardProps(scope, buildThermalComfortInfo(scope, unitsMap, name, state, unitInfo?.id));
    },
    [name, scope, state, type, unitInfo?.id, unitsMap],
  );

  const showStateHint = scope === 'state' && !name;
  const showUnitHint = scope === 'state' && selected;

  return (
    <MapInfoContainer>
      {showStateHint ? (<StateHint />) : (
        <>
          <InfoCard
            name={name ?? ''}
            onClose={onCloseInfoCard}
            scope={scope}
            {...infoProps}
            unitInfo={unitInfo}
          />
          {showUnitHint && (
            <UnitHint />
          )}
        </>
      )}
    </MapInfoContainer>
  );
}
